import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedRecipientResourceToEditId } from 'scenes/BulletinBoard/BulletinBoardSlice';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchUpdateResidentResource } from '../services/patchUpdateResidentResource.service';

export const updateResidentResource = createAsyncThunk(
  'bulletinBoard/updateResidentResource',
  async (updateAttributes, { getState }) => {
    const selectedRecipientResourceToEditId =
      selectSelectedRecipientResourceToEditId(getState());

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchUpdateResidentResource(
      selectedProjectId,
      selectedRecipientResourceToEditId,
      updateAttributes
    );

    return response;
  }
);
